
import React, { useState, useEffect } from 'react'; 
import { Form, FormGroup, Spinner, Alert, Fade } from 'reactstrap';
import { ButtonLogin, InputLogin, FormContainer, EyeIcon } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import api from '../../services/client/api';
import cookie from '../../services/cookie/index';

function LoginAdmin() {
useEffect(() => {
    document.title = "Área Paciente | Painel Admin";
  }, []);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [inProgress, setInProgress] = useState(false);
  const history = useHistory();
  const [showPassword, setShowPassword] = useState(false);
  const [loginAttempts, setLoginAttempts] = useState(0);
  const [alertError, setAlertError] = useState('');
  const [showAlert, setShowAlert] = useState(false);

   useEffect(() => {
      if (alertError) {
        setShowAlert(true); // mostra com fade
  
        const timeout = setTimeout(() => {
          setShowAlert(false); // começa a esconder com fade
          // depois que sumir, limpa o conteúdo
          setTimeout(() => setAlertError(''), 300); // tempo igual ao da animação
        }, 5000);
  
        return () => clearTimeout(timeout);
      }
    }, [alertError]);




const loginAdmin = async (e) => { 
    e.preventDefault();
  
  
  setInProgress(true);

  try {
    const response = await api().user().loginAdmin({ username, password });
       await cookie().set("username", username, 60 / 1440);

      switch (response.status) {
        case 401:
          const newLoginAttempts = loginAttempts + 1;
          setLoginAttempts(newLoginAttempts);
          setAlertError('error');
          break;
  
        case 200:
          if (response.output?.user) {
           await cookie().set("tokenAdm", response.output.token, 60 / 1440);
           await cookie().set("role", response.output.user.role);
            history.replace({
              pathname: '/admin-panel'
            });
           
          }
          break;
  
        default:
          // Trate outros status inesperados aqui se necessário
          break;
      }
  
    } catch (err) {
      console.error('Erro ao fazer login:', err);
    } finally {
      setInProgress(false);
    }
  };
  

return (
  <>
    <FormContainer>
      <h1>Admin panel</h1>
      <Form onSubmit={loginAdmin}>
               <FormGroup>
                  <span style={{
                    display: 'block',
                    marginBottom: '5px',
                    fontWeight: 650,
                    fontSize: '17px',
                    color: '#6c757d',
                    textAlign: 'left',
                  }}>
                    Login:
                  </span>
                  <InputLogin
                    type="text"
                    placeholder="Digite seu Login"
                    value={username}
                    maxLength="14"
                      onChange={(e) => {
                      setUsername(e.target.value);
                    }}
                    required
                    autoComplete="username"
                  />
                </FormGroup>

        <FormGroup>
          <span style={{
            display: 'block',
            marginBottom: '5px',
            fontWeight: 650,
            fontSize: '17px',
            color: '#6c757d',
            textAlign: 'left',
          }}>
            Senha:
          </span>
          <div style={{ position: 'relative' }}>
            <InputLogin
              type={showPassword ? "text" : "password"}
              placeholder="Digite sua senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
            <EyeIcon onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}>
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </EyeIcon>
          </div>
        </FormGroup>

 
          <ButtonLogin color="primary" type="submit" title="Para acessar você deve fornecer as credenciais de acesso, ou criar uma conta.">
            {inProgress ? <Spinner size="sm" color="light" /> : 'Acessar'}
            <FontAwesomeIcon icon={faArrowRight} />
          </ButtonLogin>

            <div>
                  <center>
            <Fade in={showAlert} timeout={400}>
                  {alertError && (
                    <Alert color="danger">
                      Login ou senha incorretos. 
                    </Alert>
                  )} 
                </Fade>
                </center>
                </div>
      </Form>
      </FormContainer>

    </>
  );
}

export default LoginAdmin;
